import React from 'react';
import NavBar from '../NavBar/NavBar';
import { Outlet } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import pattern from '../../assets/Images/pattern.png'

const Main = () => {
  return (
    <div  className="bg-zinc-700 font-manrope scroll-smooth  tracking-wide" style={{ backgroundImage: `url(${pattern})` }}>
      <NavBar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Main;